<template>
  <HeadlineComponent>Neuen Gast anlegen</HeadlineComponent>
  <Form class="form-horizontal" @submit="create">
   <GuestForm :possibleUsers="possibleUsers" :eventId="$route.params.event"></GuestForm>
    <div class="form-group">
      <LoadingButton class="btn-primary" :loading="loading">Hinzufügen</LoadingButton>
    </div>
  </Form>
</template>

<script>
import { mapActions } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import guestService from "@/services/guest.service.js";
import LoadingButton from "@/components/LoadingButton.vue";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import { Form } from 'vee-validate';
import { setErrors } from '@/helper/ErrorToActions.js';
import GuestForm from "@/components/GuestForm.vue";
import * as Sentry from '@sentry/vue';

export default {
  name: "CreateGuestView",
  components: { LoadingButton, HeadlineComponent, Form, GuestForm },
  data() {
    return {
      loading: false,
      possibleUsers: []
    }
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: 'add' }),
    async create(data, actions) {
      this.loading = true;
      try {
        await guestService.create(this.$route.params.event, data);
        this.addAlert('success', 'Der Gast wurde erfolgreich angelegt');
        window.scrollTo(0, 0);
        this.$router.push(`/events/${this.$route.params.event}/guest`);
      } catch (e) {
        if (e && e.response && e.response.status === 420) {
          this.possibleUsers = e.response.data;
          actions.setFieldValue("connected_user", "00000000-0000-0000-0000-000000000000");
        } else if (e && e.response && e.response.data && e.response.data.errors) {
          setErrors(e.response.data.errors, actions)
        } else if (e) {
          Sentry.captureException(e);
          this.addAlert('danger', "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
      this.loading = false;
    }
  }
}
</script>

<style scoped></style>